module.exports = __webpack_public_path__ + "static/shikakoe-f6367bd9b7f092105379fa94d66ffde6.png";